import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('input', this.formatIssn.bind(this))
  }

  formatIssn(event) {
    // Remove any non-alphanumeric characters
    let value = event.target.value.replace(/[^0-9A-Z]/gi, '')

    // Convert to uppercase
    value = value.toUpperCase()

    // Add hyphen after 4 characters
    if (value.length > 4) {
      value = value.slice(0, 4) + '-' + value.slice(4)
    }

    // Limit to 9 characters (4 + hyphen + 4)
    value = value.slice(0, 9)

    event.target.value = value
  }
}
